<template>
  <button
    class="base"
    :class="{ layout: flexlayout }"
    :style="{
      width: width + 'px',
      background: background,
      color: color,
      border: border,
    }"
    @click="handleClick"
  >
    <span>{{ text }}</span>
  </button>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({})
export default class Button extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  text!: string;
  @Prop({
    type: String,
    default: '',
  })
  width!: string;
  @Prop({
    type: String,
    default: '',
  })
  background!: string;
  @Prop({
    type: Boolean,
    default: false,
  })
  flexlayout!: boolean;
  @Prop({
    type: String,
    default: '',
  })
  color!: string;
  @Prop({
    type: String,
    default: '',
  })
  border!: string;
  handleClick() {
    this.$emit('click');
  }
}
</script>

<style lang="scss" scoped>
.base {
  width: calc(100% - 64px);
  height: 88px;
  color: #fff;
  font-size: 28px;
  background: rgba(94, 94, 94, 100);
  border: none;
  border-radius: 16px;
  outline: none;
}
.base.layout {
  width: 331px;
}
</style>